import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

const showNotification = (state, payload): any => ({
  ...state,
  ...payload,
})

const hideNotification = (): any => initialState

export default createReducer((on) => {
  on(actions.showNotification, showNotification)
  on(actions.hideNotification, hideNotification)
}, initialState)
